import { useCallback } from 'react';
import { useFeatureTranslation } from './useFeatureTranslation';

/** What the UI calls a master account's own books ("Moje kancelář", master-account-board plan §3.1). */
export function useOwnBooksLabel(): string {
  const t = useFeatureTranslation('shared.accountRelation');
  return t('ownBooks');
}

/**
 * Display name of a master account's client: the own books read "Moje kancelář" instead of their stored
 * name, which is the master account's own.
 */
export function useAccountRelationName(): (
  name: string,
  isOwnBooks: boolean | undefined
) => string {
  const ownBooksLabel = useOwnBooksLabel();
  return useCallback((name, isOwnBooks) => (isOwnBooks ? ownBooksLabel : name), [ownBooksLabel]);
}
